import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';

import theme from '../theme/index';

interface IProps {
    title: string;
}

class Title extends React.Component<IProps> {
    public render() {
        return (
            <div className={css(styles.header)}>
                <h1 className={css(styles.title, styles.underline)}>
                    {this.props.title}
                </h1>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    header: {
        marginTop: 40,
    },
    title: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 20,
        },
        fontSize: 30,
        color: theme.title,
        display: 'inline-block',
        paddingBottom: 5,
    },
    underline: {
        borderBottom: `3px solid ${theme.tertiaryColor}`,
    },
});

export default Title;
